import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TrendingUp, Mic, Briefcase, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Strategic Consulting",
  description: "Personalized business strategy sessions to help you scale your operations, optimize revenue models, and build a lasting brand legacy.",
  icon: Briefcase,
  link: "/ConsultingPage",
  linkText: "Explore Consulting"
}, {
  title: "Media & Podcasting",
  description: "Insights on creating high-impact content, growing an audience, and monetizing your message through modern media channels.",
  icon: Mic,
  link: "/BlogPage",
  linkText: "Listen to Podcast"
}, {
  title: "Investment & Wealth",
  description: "Exclusive access to vetted investment opportunities and financial frameworks designed for long-term wealth preservation and growth.",
  icon: TrendingUp,
  link: "/AboutMePage",
  linkText: "Learn More"
}];
export default function HowICanHelpYou() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}